import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AgentLicense } from '../../../../../common/js/agent/AgentLicense';
import { cache } from '../../../../../common/js/rxjs/operators/cache';
import { Controller } from '../../Controller';
import { AdvisorSelectionService } from '../advisor-selection/advisor-selection.service';
import { AgentAmorphicService } from '../amorphic/amorphic.service';

@Injectable({
  providedIn: 'root',
})
export class AgentLicenseService {
  private readonly controller: Controller;
  private readonly cache$: Observable<AgentLicense[]>;

  constructor(private amorphicService: AgentAmorphicService, private advisorSelectionService: AdvisorSelectionService) {
    this.controller = this.amorphicService.controller as Controller;
    this.cache$ = this.createStateLicense$();
  }

  private createStateLicense$(): Observable<AgentLicense[]> {
    return this.advisorSelectionService.agent$.pipe(
      switchMap(({ producerId }) => this.controller.getStateLicenses(producerId)),
      cache()
    );
  }

  getStateLicense(): Observable<AgentLicense[]> {
    return this.cache$;
  }
}
